/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { devicesRouterDuocolor } from "../assets/devices-router-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconDevicesRouterDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={devicesRouterDuocolor.svg} />
);

IllustrativeIconDevicesRouterDuocolor.displayName = "IllustrativeIconDevicesRouterDuocolor";
